import { useRef } from "react";
import DatePicker from "@/assets/icons/datePicker.png";
import "./dobCom.css"

export default function DobCom(props: any) {
    const dateInputRef = useRef<HTMLInputElement>(null);


    const handleIconClick = () => {
        if (dateInputRef.current) {
            dateInputRef.current.showPicker?.();
            dateInputRef.current.click();
        }
    };

    return (
        <div className="relative w-[100%]">
            <style>{`
                input[type="date"]::-webkit-inner-spin-button,
                input[type="date"]::-webkit-calendar-picker-indicator {
                    opacity: 0;
                    position: absolute;
                    right: 0;
                }
            `}</style>


            <input
                onChange={props.onChange}
                type="date"
                value={props.value}
                ref={dateInputRef}
                className="profileSectionDobComInputBox pl-3 w-[100%] pr-10 py-2 rounded-[5px]"
            />
            <img
                src={DatePicker}
                alt="Custom calendar icon"
                className="w-[17px] cursor-pointer absolute right-3 top-1/2 -translate-y-1/2"
                onClick={handleIconClick}
            />
        </div>
    );
};
